<main class="p-6 lg:p-12 space-y-6 lg:space-y-10 min-h-screen flex flex-col text-text-primary">
  <ng-content />
</main>
